import { Alert } from '@mui/material';

const ErrorAlert = ({ message }: { message: string }) => (
  <Alert severity="error" sx={{ my: 2 }}>
    {message}
  </Alert>
);

export default ErrorAlert; 
